import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import MaskedInput from 'react-text-mask';

require('../../styles/components/_material-text-input.scss');

export interface Props extends WrappedFieldProps {
    label: string;
    placeholder?: string;
    mask: [];
    handleOnBlur?: (value: string) => void;
}

const InputMask = (props: any) => {
    const { input, meta, ...custom } = props;
    return <MaskedInput {...input} {...custom} />;
};

export class MaskedTextInput extends React.Component<Props, {}> {
    render() {
        const {
            label,
            input: { onFocus, onBlur, ...input },
            mask,
            handleOnBlur,
            meta: { error, touched },
            placeholder,
        } = this.props;

        const hasValue = input.value.length !== 0;
        return (
            <div className='MaterialTextInput'>
                <InputMask
                    mask={mask}
                    {...input}
                    onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                        e.currentTarget.placeholder = (placeholder && placeholder) || '';
                        onFocus(e);
                    }}
                    onBlur={(e: React.SyntheticEvent<HTMLInputElement>) => {
                        e.currentTarget.placeholder = '';
                        onBlur(e);
                        if (!!handleOnBlur) {
                            handleOnBlur(e.currentTarget.value);
                        }
                    }}
                    type='text'
                    className={'MaterialTextInput--input' + (touched && error ? ' MaterialTextInput--input__has-error' : '')}
                />
                <span className='MaterialTextInput--bar' />
                <label className={'MaterialTextInput--label' + (hasValue ? ' MaterialTextInput--label__active' : '')}>{label}</label>
                {touched && error && <span className='MaterialTextInput--error'>{error}</span>}
            </div>
        );
    }
}

export default MaskedTextInput;
